export enum FileVariant {
  DOCUMENT_APPRAISER = 'document_appraiser',
  FILES_APPRAISER = 'files_appraiser',
  PHOTO_OUTSIDE_PROPERTY = 'photo_outside',
  PHOTO_INSIDE_PROPERTY = 'photo_inside',
  FLOOR_PLAN = 'floor_plan',
  PHOTOS_INSIDE_PROPERTY = 'photos_inside',
  PHOTOS_OUTSIDE_PROPERTY = 'photos_outside',
  DOCUMENT_PROPERTY = 'document_property',
}

export interface IFile {
  id?: string;
  name: string;
  link: string;
}

export enum FileType {
  PDF = 'pdf',
}
